import * as React from 'react'

import Dots from './Dots.js'
import './loading.scss'

const Default = () => <div className='loading-default-container' data-testid='default-loading'><Dots /></div>

export default Default
